import { runtimeEnv } from '../assets/core/runtime-env';

export const environment = {
	production: false,
	cmsUrl: runtimeEnv.cmsUrl,
	imgUrl: '',
	apiUrl: runtimeEnv.apiUrl,
	googleRecaptchaKey: runtimeEnv.googleRecaptchaKey,
	host: runtimeEnv.host,
	optimumUrl: runtimeEnv.optimumUrl,
	mobilizeEthicalPage: runtimeEnv.mobilizeEthicalPage || 'https://report.whistleb.com/en/portal/renaultgroup/',
	nuveiEnvironment: 'stg',
	nuveiCode: runtimeEnv.nuveiCode,
	nuveiKey: runtimeEnv.nuveiKey,//
};

